export default function getNavbarHeight(Breakpoints) {
  const mobileNavbarHeight = 60;
  const defaultNavbarHeight = 80;

  const isMobile = Breakpoints.isS();

  return isMobile ? mobileNavbarHeight : defaultNavbarHeight;
}
